import ApiService from 'services/ApiService';
import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  lists: [],
  error: null
};

const slice = createSlice({
  name: 'meltingFurnaceLast',
  initialState,
  reducers: {
    hasError(state, action) {
      state.error = action.payload;
    },
    getLists(state, action) {
      state.lists = action.payload;
    }
  }
});

export const { getLists } = slice.actions;
export default slice.reducer;

export function getMeltingFurnaceLastList() {
  return async (dispatch) => {
    try {
      const response = await ApiService.get({ path: '/modbus/last' });
      dispatch(slice.actions.getLists(response.data));
      console.log('용해로', response.data);
    } catch (error) {
      dispatch(slice.actions.hasError(error.message || 'An error occurred'));
    }
  };
}
